import type { Role } from "@/app/role";
import type { RoleUpgradeRequestStatus } from "@/app/profile/profile.types";

export type RoleUpgradeDecision = "APPROVE" | "REJECT";

export interface RoleUpgradeRequestListItem {
  userId: string;
  readableId: string;
  firstName: string;
  email: string;
  phone: string;
  currentRole: Role;
  targetRole: Role;
  status: RoleUpgradeRequestStatus;
  requestedAt: string;
  decidedAt: string | null;
  decidedByReadableId: string | null;
  decidedByEmail: string | null;
  remarks: string | null;
}

export interface RoleUpgradeDecisionRequest {
  targetRole: Role;
  remarks: string;
  decision: RoleUpgradeDecision;
}

export interface RoleUpgradeDecisionResponse {
  userId: string;
  readableId: string;
  role: Role;
  requestStatus: RoleUpgradeRequestStatus | null;
}

// Filter options for the admin listing — NOT_APPLIED isn't a stored status,
// so it's excluded (filtering by it yields an empty list per the backend).
export const ROLE_UPGRADE_STATUS_FILTERS = ["IN_PROGRESS", "APPROVED", "REJECTED"] as const;
export type RoleUpgradeStatusFilter = (typeof ROLE_UPGRADE_STATUS_FILTERS)[number];
